import React from 'react';
import { IconChevronLeft } from '../../shared/Icons'; // Assuming Icons.js is in src/shared

export const PageHeader = ({ title, onBack, rightContent = null }) => {
    const gradientBackground = 'linear-gradient(133deg, #46B654 -8.24%, #4B63A9 100.18%)';
    return (
        <header
            style={{ background: gradientBackground }}
            className="text-white px-3 py-3 sm:p-4 flex items-center gap-2 sticky top-0 z-[9999] shadow-md rounded-b-[18px]"
        >
            <div className="flex-shrink-0 w-10">
                {onBack && (
                    <button
                        type="button"
                        onClick={onBack}
                        aria-label="Kembali"
                        className="text-white p-2 -ml-1 rounded-lg hover:bg-white/15 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white min-h-[44px] min-w-[44px] flex items-center justify-center"
                    >
                        <IconChevronLeft className="w-6 h-6" aria-hidden />
                    </button>
                )}
            </div>
            <h1 className="text-lg sm:text-xl font-semibold text-center min-w-0 flex-1 truncate px-1">{title}</h1>
            <div className="flex-shrink-0 flex justify-end items-center min-w-0 max-w-[min(100%,11rem)] sm:max-w-[min(100%,18rem)]">
                {rightContent ? rightContent : <div className="w-6 h-6 shrink-0" aria-hidden />}
            </div>
        </header>
    );
};

export const LoadingSpinner = ({ message }) => (
    <div className="text-center p-20">
        <div className="w-12 h-12 border-4 border-green-500 border-dashed rounded-full animate-spin mx-auto"></div>
        <p className="text-gray-600 dark:text-gray-400 mt-4">{message}</p>
    </div>
);

export const ErrorMessage = ({ message }) => (
    <div className="bg-red-100 dark:bg-red-900/30 border-l-4 border-red-500 text-red-700 dark:text-red-300 p-4 rounded-md" role="alert">
        <p className="font-bold">Terjadi Kesalahan</p>
        <p>{message}</p>
    </div>
);
